export class PatientRecordDataObject {
	/**
	 * @param {?string} [id=null]
	 * @param {string} [ownerId='']
	 * @param {string} [firstName='']
	 * @param {string} [middleName='']
	 * @param {string} [lastName='']
	 * @param {string} [telephone='']
	 * @param {string} [mobilePhone='']
	 * @param {string} [email='']
	 * @param {?Date} [birthDate=null]
	 * @param {string} [address='']
	 * @param {?Object} [city=null]
	 * @param {?number} [payedTreatments=null]
	 * @param {?number} [finishedTreatments=null]
	 * @param {?number} [remainingTreatments=null]
	 * @param {?number} [totalPayed=null]
	 * @param {string} [recommendationId='']
	 * @param {string} [recommendationName='']
	 * @param {string} [anamnesis='']
	 * @param {?number} [totalDebt=null]
	 */
	constructor(
		id = null, ownerId = '', firstName = '', middleName = '', lastName = '', 
		telephone = '', mobilePhone = '', email = '', birthDate = null, address = '', city = null, payedTreatments = null,
		finishedTreatments = null, remainingTreatments = null, totalPayed = null, recommendationId = '', 
		recommendationName = '', anamnesis  = '', totalDebt = null, 
	) {
		this.id = id;
		this.ownerId = ownerId;
		this.firstName = firstName;
		this.middleName = middleName;
		this.lastName = lastName;
		this.telephone = telephone;
		this.mobilePhone = mobilePhone;
		this.email = email;
		this.birthDate = birthDate;
		this.address = address;
		this.city = city;
		this.payedTreatments = payedTreatments; 
		this.finishedTreatments = finishedTreatments; 
		this.remainingTreatments = remainingTreatments; 
		this.totalPayed = totalPayed;
		this.recommendationId = recommendationId;
		this.recommendationName = recommendationName;
		this.anamnesis = anamnesis;
		this.totalDebt = totalDebt;
	}
}

